module.exports = __webpack_public_path__ + "img/hk_room_floorplan_10.961b62ca.png";